
const errors = {
  required: 'Campo obligatorio',
  UserNotFoundException: 'El usuario no existe',
  NotAuthorizedException: 'Usuario y/o contraseña incorrectos'
}

const messages = { errors }

export default messages;